/** Pipe details and usage**/
/**
 * Pipe Name: 'contractDetails'
 * Inputs and type: lineOfBusiness(string) and contractID(string)
 *
 * Example: {{ value | contractDetails:'BUName':'E2345678' }} (appends hashcode to contractDetails link if bu is Annuity)
**/

import { Pipe, PipeTransform } from '@angular/core';
import * as jsSHA from 'jssha';

@Pipe({ name: 'contractDetails' })
export class ContractDetailsPipe implements PipeTransform {
    transform(value: string, lineOfBusiness: string, contractID: string): any {
        if (!value) {
            return;
        }
        if (lineOfBusiness && contractID) {
            if (lineOfBusiness === 'Annuity') {
                let shaObj = new jsSHA('SHA-512', 'TEXT');
                shaObj.update(contractID);
                let hash = shaObj.getHash('HEX');
                if (/\?/.test(value)) {
                    value += '&annuities_requestId=' + hash;
                } else {
                    value += '?annuities_requestId=' + hash;
                }
            }
            return value;
        }
    }
}
